module.exports = __webpack_public_path__ + "img/drink_cola.d34a2efa.png";